export const APP_OFFERS_CALLOUT_SOURCE = 'ec_site_offers_callout';
